"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pjson = require('../../package.json'); // tslint:disable-line no-var-requires
function getLibraryVersion() {
    return pjson.version;
}
exports.getLibraryVersion = getLibraryVersion;
//# sourceMappingURL=getLibraryVersion.js.map